import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';
import { HttpHeaders } from '@angular/common/http';
import { CertificateMst, PatientCertificate } from '../../../interfaces/patient-services/certificate';

@Injectable()
export class CertificateApi {
  private readonly apiController: string = 'patCert/';

  constructor(private api: HttpService) { }

  list(url: string, options?: any): Observable<any[]> {
    const header = new HttpHeaders({"Accept":"application/vnd.ezovion.hateoas+json"});
    //header.append('Content-Type', 'applications/json');
    //headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    //header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.directGet(url,{headers:{"Accept":"application/vnd.ezovion.hateoas+json","Content-Type":"application/javascript"}});
  }

  getById(url: string, options?: any): Observable<CertificateMst> {
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    header.append('Content-Type','application/javascript');
    return this.api.get(url,header);
  }

  add(url:string, data: any):Observable<CertificateMst>{
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    header.append('Content-Type','application/javascript');
    return this.api.directPost(url, data, header);
  }

  

  update(url:string, data: CertificateMst):Observable<any>{
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    header.append('Content-Type','application/javascript');
    return this.api.directPut( url, data, header);
  }

  delete(url: string):Observable<any>{
    return this.api.directDelete(url);
  }
}
